// Slim infinite-scroll marquee strip that calls out Dr. Maggie's focus areas.
const ITEMS = [
  "Dr. Maggie",
  "Rheumatology",
  "Joint Health",
  "Autoimmune Education",
  "Women's Health",
  "Minority Health",
  "Lupus Awareness",
  "Movement is Medicine",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      aria-hidden
      className="relative py-5 bg-gradient-to-r from-plum via-royal to-violet text-white overflow-hidden"
    >
      <div
        className="flex gap-12 whitespace-nowrap"
        style={{ animation: "marquee 30s linear infinite" }}
      >
        {row.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-12 font-display text-[12px] tracking-[0.32em] uppercase"
          >
            {t}
            <span className="opacity-50">.</span>
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
